import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=e408ca86&scoped=true&"
import script from "./classification.vue?vue&type=script&lang=js&"
export * from "./classification.vue?vue&type=script&lang=js&"
import style0 from "./classification.vue?vue&type=style&index=0&id=e408ca86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e408ca86",
  null
  
)

export default component.exports